module.exports = __webpack_public_path__ + "c8e2bc5e05a3fae35b2d9a83fa7be949.pdf";